// Component MarginInput
import { useState, useEffect, useCallback } from 'react'
import styles from './MarginInput.module.css'
import CustomNumber from '../../../../../../../components/CustomNumber/CustomNumber'

import { InputNumber } from 'antd'

import {
  SvgIconMarginTop,
  SvgIconMarginLeft,
  SvgIconMarginBottom,
  SvgIconMarginRight,
  SvgIconPadlock,
} from '../../../../../../../components/svg/SvgComponents'

function decomposeMarginValue(value) {
  try {
    const values = value.split(' ').map((val) => parseInt(val, 10))
    let margins = [0, 0, 0, 0] // Default margins

    switch (values.length) {
      case 1:
        return [values[0], values[0], values[0], values[0]]
      case 2:
        return [values[0], values[1], values[0], values[1]]
      case 3:
        return [values[0], values[1], values[2], values[1]]
      case 4:
        return [values[0], values[1], values[2], values[3]]
      default:
        console.error("La valeur de marge fournie n'est pas correcte")
        return margins
    }
  } catch (error) {
    console.error(
      'Erreur lors de la décomposition de la valeur de marge : ',
      error
    )
    return [0, 0, 0, 0]
  }
}

function MarginInput({ name, value, onChange }) {
  const [topValue, rightValue, bottomValue, leftValue] =
    decomposeMarginValue(value)

  const [top, setTop] = useState(topValue)
  const [right, setRight] = useState(rightValue)
  const [bottom, setBottom] = useState(bottomValue)
  const [left, setLeft] = useState(leftValue)

  useEffect(() => {
    const [topValue, rightValue, bottomValue, leftValue] =
      decomposeMarginValue(value)

    setTop(topValue)
    setRight(rightValue)
    setBottom(bottomValue)
    setLeft(leftValue)
  }, [value])

  useEffect(() => {
    const margin = `${top}px ${right}px ${bottom}px ${left}px`
    console.log('margin', margin)
    onChange(margin, name)
  }, [top, right, bottom, left])

  const handleChange = useCallback(
    (name, e) => {
      let val = e.target.value

      // Vérifiez si la valeur est nulle, si c'est le cas, définissez-la à 0
      val = val || 0

      switch (name) {
        case 'top':
          setTop(val)
          break
        case 'right':
          setRight(val)
          break
        case 'bottom':
          setBottom(val)
          break
        case 'left':
          setLeft(val)
          break
        default:
          break
      }
    },
    [setTop, setRight, setBottom, setLeft]
  )

  // Utilisez un input de type number pour le margin
  return (
    <div className={styles.container}>
      <div className={styles.container__inputs}>
        <div
          className={`${styles.padding__top__input__container} ${styles.center}`}
        >
          <CustomNumber
            name="top"
            value={top}
            onChange={(val) => handleChange('top', val)}
            min={0}
            step={1}
          />
        </div>
        <div
          className={`${styles.padding__right__input__container} ${styles.center}`}
        >
          <CustomNumber
            name="right"
            value={right}
            onChange={(val) => handleChange('right', val)}
            min={0}
            step={1}
          />
        </div>
        <div
          className={`${styles.padding__bottom__input__container} ${styles.center}`}
        >
          <CustomNumber
            name="bottom"
            value={bottom}
            onChange={(val) => handleChange('bottom', val)}
            min={0}
            step={1}
          />
        </div>
        <div
          className={`${styles.padding__left__input__container} ${styles.center}`}
        >
          <CustomNumber
            name="left"
            value={left}
            onChange={(val) => handleChange('left', val)}
            min={0}
            step={1}
          />
        </div>
        <div className={styles.bind__indicators__container}>
          <div
            className={`${styles.icon__padding__top__container} ${styles.center}`}
          >
            <div className={styles.icon}>
              <SvgIconMarginTop />
            </div>
          </div>
          <div
            className={`${styles.icon__padding__right__container} ${styles.center}`}
          >
            <div className={styles.icon}>
              <SvgIconMarginRight />
            </div>
          </div>
          <div
            className={`${styles.icon__padding__bottom__container} ${styles.center}`}
          >
            <div className={styles.icon}>
              <SvgIconMarginBottom />
            </div>
          </div>
          <div
            className={`${styles.icon__padding__left__container} ${styles.center}`}
          >
            <div className={styles.icon}>
              <SvgIconMarginLeft />
            </div>
          </div>

          <div
            className={`${styles.icon__padding__center__container} ${styles.center}`}
          >
            <div className={styles.icon}>
              <SvgIconPadlock />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MarginInput
